import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Error from '../views/Error.vue'

Vue.use(VueRouter)

const WORKER = {
    scope: 'worker',
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/addlead',
        name: 'addlead',
        component: () => import('@/views/dicts/addLead.vue'),
        meta: {
            requiredAuth: false,
        },
    },
    {
        path: '/alldicts',
        name: 'AllDicts',
        component: () => import('@/views/dicts/AllDicts.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/faq',
        name: 'DictionaryList',
        component: () => import('@/views/dicts/DictionaryList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/faq/:id',
        name: 'DictionaryData',
        component: () => import('@/views/dicts/DictionaryData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/bizregion',
        name: 'bizregion',
        component: () => import('@/views/dicts/bizregion.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/bizregion/:id',
        name: 'bizregionItemData',
        component: () => import('@/views/dicts/bizregionItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/territorie',
        name: 'territorie',
        component: () => import('@/views/dicts/territorie.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/territorie/:id',
        name: 'territorieItemData',
        component: () => import('@/views/dicts/territorieItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/office',
        name: 'office',
        component: () => import('@/views/dicts/office.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/office/:id',
        name: 'officeItemData',
        component: () => import('@/views/dicts/officeItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/district',
        name: 'districtList',
        component: () => import('@/views/dicts/districtList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/district/:id',
        name: 'districtItemData',
        component: () => import('@/views/dicts/districtItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/sourceName',
        name: 'sourceNameList',
        component: () => import('@/views/dicts/sourceNameList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/sourceName/:id',
        name: 'sourceNameItemData',
        component: () => import('@/views/dicts/sourceNameItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/leadType',
        name: 'leadTypeList',
        component: () => import('@/views/dicts/leadTypeList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/leadType/:id',
        name: 'leadTypeItemData',
        component: () => import('@/views/dicts/leadTypeItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/objList',
        name: 'objList',
        component: () => import('@/views/dicts/objList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/objList/:id',
        name: 'objItemData',
        component: () => import('@/views/dicts/objItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/modelList',
        name: 'modelList',
        component: () => import('@/views/dicts/modelList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/modelList/:id',
        name: 'modelItemData',
        component: () => import('@/views/dicts/modelItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/modelListRoof',
        name: 'modelListRoof',
        component: () => import('@/views/dicts/modelListRoof.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/modelListRoof/:id',
        name: 'modelRoofItemData',
        component: () => import('@/views/dicts/modelRoofItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/calcdictList',
        name: 'calcdictList',
        component: () => import('@/views/dicts/calcdictList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/calcdictList/:code',
        name: 'calcdictGroupData',
        component: () => import('@/views/dicts/calcdictGroupData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/calcdictList/:code/:id',
        name: 'calcdictItemData',
        component: () => import('@/views/dicts/calcdictItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/configList',
        name: 'configList',
        component: () => import('@/views/dicts/configList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/configList/:id',
        name: 'configItemData',
        component: () => import('@/views/dicts/configItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/roomList',
        name: 'roomList',
        component: () => import('@/views/dicts/roomList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/roomList/:id',
        name: 'roomItemData',
        component: () => import('@/views/dicts/roomItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/bannersList',
        name: 'bannersList',
        component: () => import('@/views/dicts/bannersList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/bannersList/:id',
        name: 'bannersItemData',
        component: () => import('@/views/dicts/bannersItemData.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/saleschannalList',
        name: 'saleschannalList',
        component: () => import('@/views/dicts/saleschannalList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/saleschannalList/:id',
        name: 'saleschannalItemData',
        component: () => import('@/views/dicts/saleschannalItemData'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/modelList/windowParamsList',
        name: 'windowParamsList',
        component: () => import('@/views/dicts/windowParamsList.vue'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/windowParamsList/:id',
        name: 'windowParamItemData',
        component: () => import('@/views/dicts/windowParamItemData'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: '/DictionaryList/windowParamsList/:id/:paramId',
        name: 'windowParamsPropData',
        component: () => import('@/views/dicts/windowParamsPropData'),
        meta: {
            requiredAuth: true,
            authType: WORKER,
        },
    },
    {
        path: "/error",
        name: "error",
        components: { default: Error },
        props: {}
    },
    {
        path: "*",
        name: "error404",
        components: { default: Error },
        props: {}
    }
]

const router = new VueRouter({
    mode: 'history',
    base: "/",
    routes
})

export default router
